import { useMutation } from 'react-query';
import ItemServiceApi, { UpdateItem } from '../../Api/item-service';
import toast from '../../../Components/Toast/Toast';

type UpdateItemParams = {
  userId: string;
  itemId: string;
  data: UpdateItem;
};

export const useSaveVendorCatalogItem = () =>
  useMutation(
    (params: UpdateItemParams) =>
      ItemServiceApi.updateVendorItem(
        params.userId,
        params.itemId,
        params.data,
      ),
    {
      onError: (error) => {
        toast({ title: 'Error saving item.' }, { type: 'error' });
        console.error('error while saving the item', error);
      },
    },
  );
